import { Box } from '@mui/material';
import { REPORT_CHART_FONT } from './chart-theme';

export type ReportChartLegendItem = {
  label: string;
  color: string;
};

type ReportChartLegendProps = {
  items: ReportChartLegendItem[];
  orientation?: 'horizontal' | 'vertical';
};

export const ReportChartLegend: React.FC<ReportChartLegendProps> = ({ items, orientation = 'horizontal' }) => {
  const isVertical = orientation === 'vertical';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isVertical ? 'column' : 'row',
        flexWrap: isVertical ? 'nowrap' : 'wrap',
        alignItems: isVertical ? 'flex-start' : 'center',
        justifyContent: isVertical ? 'flex-start' : 'center',
        gap: isVertical ? '16px' : '24px',
        px: isVertical ? 0 : 2,
        py: isVertical ? 0 : 1,
      }}
    >
      {items.map((item) => (
        <Box
          key={item.label}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Box
            sx={{
              width: 18,
              height: 8,
              borderRadius: '2px',
              backgroundColor: item.color,
              flexShrink: 0,
            }}
          />
          <Box
            component="span"
            sx={{
              fontFamily: REPORT_CHART_FONT.family,
              fontSize: `${REPORT_CHART_FONT.size}px`,
              fontWeight: REPORT_CHART_FONT.weight,
              lineHeight: '20px',
              color: REPORT_CHART_FONT.color,
              whiteSpace: 'nowrap',
            }}
          >
            {item.label}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
